import { render, staticRenderFns } from "./ModalConsignmentUpdate.vue?vue&type=template&id=1872e578&"
import script from "./ModalConsignmentUpdate.vue?vue&type=script&lang=js&"
export * from "./ModalConsignmentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports